module.exports = __webpack_public_path__ + "img/logo-paktalent.a1d8e823.png";